import React from 'react';
import ReactDOM from "react-dom";
import { observer } from 'mobx-react';
import loadable from '@loadable/component';
import pageStore from 'stores/PageStore';
import payloadStore from 'stores/PayloadStore';
import constants from 'Constants';
import * as utils from 'Utils';
import 'styles/main.scss';



@observer
class Prompts extends React.Component {
  constructor(props) {
    super(props);
  }

  getPrompts = () => {
    const prompts = payloadStore.prompts.filter((prompt) => prompt.display || prompt.displayLauncher);
    if (prompts.length === 0) return;

    const Prompt = loadable(() => import('containers/Prompt'));
    return (
      <div>
        {prompts.map((prompt, idx) =>
          <Prompt
            key={prompt.id}
            prompt={prompt}
          />
        )}
      </div>
    )
  };

  render() {
    return (
      <div className="ov-prompts">
        {this.getPrompts()}
      </div>
    )
  }
};


@observer
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    utils.executeCallback(pageStore.onReadyCallback);

    const el = document.querySelector(".ov-app-prompt");
    if (!el) return;
    let component = <Prompts />;
    this.embedInlineWidget(component, el);
  }

  embedInlineWidget = (component, el) => {
    ReactDOM.render(<div className="ov-wrapper">{component}</div>, el);
  };

  render() {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: require('static/icons/bp-icon.svg').default}} />
        <div dangerouslySetInnerHTML={{__html: require('static/icons/fa-icon.svg').default}} />
      </div>
    )
  }
}



export default App;
